// smartStorage.js
// Handles localStorage/sessionStorage with fallback to cookies

// --- Cookie helpers ---
const setCookie = (name, value, days = 1) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; Secure; SameSite=Lax`;
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

const removeCookie = (name) => {
  setCookie(name, "", -1);
};

// --- Detect usable storage ---
let storage = null;
let type = "cookie"; // default fallback

// Safari Private Mode detection
const isSafariPrivate = (() => {
  const ua = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  if (!isSafari) return false;

  try {
    window.localStorage.setItem("__test__", "1");
    window.localStorage.removeItem("__test__");
    return false;
  } catch {
    return true;
  }
})();

if (isSafariPrivate) {
  console.warn("Safari Private Mode detected. Login persistence may not work.");
//   alert(
//     "You are in Safari Private Mode. Login will not persist after reload."
//   );
} else {
  try {
    const testKey = "__t";
    window.localStorage.setItem(testKey, "1");
    window.localStorage.removeItem(testKey);
    storage = window.localStorage;
    type = "localStorage";
  } catch (e) {
    try {
      const testKey = "__t";
      window.sessionStorage.setItem(testKey, "1");
      window.sessionStorage.removeItem(testKey);
      storage = window.sessionStorage;
      type = "sessionStorage";
    } catch (e2) {
      storage = null; // fallback to cookies
      type = "cookie";
    }
  }

}

// --- Smart Storage API ---
export const smartStorage = {
  get(key) {
    try {
      if (storage) {
        const val = storage.getItem(key);
        if (val !== null) return val;
      }
    } catch {}
    return getCookie(key);
  },

  set(key, value) {
    try {
      if (storage) storage.setItem(key, value);
    } catch {}
    setCookie(key, value, 1); // always set cookie as fallback
  },

  remove(key) {
    try {
      if (storage) storage.removeItem(key);
    } catch {}
    removeCookie(key);
  },

  type,
  isSafariPrivate,
};
